import { FaEnvelope } from 'react-icons/fa';
import { EmailDashboardView } from '../Components/EmailDashboardView';
import { EmailContactsView } from '../Components/EmailContactsView';
import { EmailListsView } from '../Components/EmailListsView';
import { EmailImportView } from '../Components/EmailImportView';
import { EmailTemplatesView } from '../Components/EmailTemplatesView';
import { EmailCampaignsView } from '../Components/EmailCampaignsView';
import { EmailQueueView } from '../Components/EmailQueueView';
import { EmailSuppressionsView } from '../Components/EmailSuppressionsView';

const base = {
    views: 'PRIVATE', roles: null, permissions: null,
    displayInHeader: false, displayInFooter: false,
    isBlockedWhenLogged: false,
};

export const EmailModule = () => [
    { ...base, path: '/dashboard/correos', component: <EmailDashboardView />, label: 'Correos', icon: <FaEnvelope />, displayInSidebar: true },
    { ...base, path: '/dashboard/correos/contactos', component: <EmailContactsView />, label: 'Contactos', icon: <FaEnvelope />, displayInSidebar: false },
    { ...base, path: '/dashboard/correos/listas', component: <EmailListsView />, label: 'Listas', icon: <FaEnvelope />, displayInSidebar: false },
    { ...base, path: '/dashboard/correos/importar', component: <EmailImportView />, label: 'Importar', icon: <FaEnvelope />, displayInSidebar: false },
    { ...base, path: '/dashboard/correos/plantillas', component: <EmailTemplatesView />, label: 'Plantillas', icon: <FaEnvelope />, displayInSidebar: false },
    { ...base, path: '/dashboard/correos/campanas', component: <EmailCampaignsView />, label: 'Campañas', icon: <FaEnvelope />, displayInSidebar: false },
    { ...base, path: '/dashboard/correos/cola', component: <EmailQueueView />, label: 'Cola e historial', icon: <FaEnvelope />, displayInSidebar: false },
    { ...base, path: '/dashboard/correos/bloqueos', component: <EmailSuppressionsView />, label: 'Bloqueos', icon: <FaEnvelope />, displayInSidebar: false },
];
